var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    style: {
      fill: "#00933b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.906 60.267c1.367 1.606 3.103 2.409 5.208 2.409 2.062 0 3.684-.776 4.867-2.328 1.182-1.551 1.774-3.564 1.774-6.038 0-2.756-.673-4.867-2.019-6.332-1.345-1.464-2.994-2.197-4.948-2.197-1.584 0-2.983.478-4.199 1.433-1.823 1.41-2.734 3.689-2.734 6.836 0 2.539.683 4.611 2.05 6.217Zm11.002-26.595c0-.76-.293-1.595-.879-2.507-.998-1.475-2.506-2.213-4.524-2.213-3.017 0-5.165 1.692-6.446 5.078-.694 1.866-1.172 4.622-1.432 8.268 1.15-1.367 2.485-2.365 4.004-2.995 1.519-.629 3.255-.944 5.208-.944 4.189 0 7.623 1.422 10.303 4.265 2.68 2.843 4.02 6.478 4.02 10.905 0 4.405-1.313 8.29-3.939 11.653-2.626 3.364-6.705 5.046-12.24 5.046-5.945 0-10.33-2.485-13.15-7.455-2.192-3.884-3.288-8.897-3.288-15.039 0-3.602.152-6.532.456-8.789.542-4.014 1.595-7.357 3.157-10.026 1.346-2.278 3.109-4.112 5.29-5.501 2.18-1.389 4.79-2.083 7.829-2.083 4.383 0 7.877 1.123 10.481 3.369 2.605 2.246 4.07 5.235 4.395 8.968h-9.245Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.96e66b6faf56c43a052689f01957e436.svg";
export { ForwardRef as ReactComponent };